import script from "./CarouselRooming.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselRooming.vue?vue&type=script&setup=true&lang=js"

import "./CarouselRooming.vue?vue&type=style&index=0&id=2c608481&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c608481"]])

export default __exports__